<template>
	<div class="h-pup">
		<el-dialog :close-on-click-modal="false" title="过期拜访计划原因提报" :visible.sync="dialogFormVisible" class="h-dialog">
		  <div class="h-formLine">
			  <el-form ::model="formLabelAlign2" :label-position="right" :rules="rules2" ref="formLabelAlign2" :inline="true"  class="demo-ruleForm h-formbLine h-dialogForm">
				 <el-form-item label="拜访客户" class="h-elformWrap-2" prop="formCon1">
					<span class="h-readOnlyTxt">青岛大学附属医院</span>
				  </el-form-item>
				  <el-form-item label="区域" class="h-elformWrap-2">
					 <span class="h-readOnlyTxt">山东省青岛市市北区</span>
				  </el-form-item> 
				  <el-form-item label="拜访时间" class="h-elformWrap-1">
					<span class="h-fl">
					  <span class="h-readOnlyTxt">2019-07-10  10:30</span>
					</span>
					<el-col class="line h-txtCenter" :span="2">至</el-col>
					<span class="h-fl">
					  <span class="h-readOnlyTxt">2019-07-10  10:30</span>
					</span>
				  </el-form-item>
				  <el-form-item label="拜访类型" class="h-elformWrap-2">
					<span class="h-readOnlyTxt">日常拜访</span>
				  </el-form-item>
				  <el-form-item label="用户渠道" class="h-elformWrap-2">
					<span class="h-readOnlyTxt">个人渠道</span>
				  </el-form-item>
			  </el-form>
			  <div class="h-formPiece">
				  <el-form ::model="formLabelAlign2" :label-position="right" :rules="rules2" ref="formLabelAlign2" :inline="true"  class="demo-ruleForm h-formbLine h-dialogForm">
					 <el-form-item label="部门/科室" class="h-elformWrap-1">
						<span class="h-readOnlyTxt">血液科</span>
					  </el-form-item>
					  <el-form-item label="关键人" class="h-elformWrap-1">
						<span class="h-readOnlyTxt">郭达</span>
					  </el-form-item> 
					  <el-form-item label="联系方式" class="h-elformWrap-1">
						<span class="h-readOnlyTxt">１８７６６３０３０１６</span>
					  </el-form-item>
					  <el-form-item label="洽谈内容" prop="formCon10" class="h-elformWrap-1">
						<span class="h-readOnlyTxt">拜访目的描述拜访目的描述拜访目的描述拜访目的描述拜访目</span>
					  </el-form-item>
				  </el-form>
			  </div>
			  <div class="h-formRow">
				<el-form ::model="formLabelAlign2" :label-position="right" :rules="rules2" ref="formLabelAlign2" :inline="true"  class="demo-ruleForm h-formbLine h-dialogForm">
					 <el-form-item label="位置信息" class="h-elformWrap-1">
						<span class="h-readOnlyTxt">
							<span>山东省</span>
							<span>青岛市</span>
							<span>市北区</span>
						</span>
						<p class="h-readOnlyTxt">
							ＸＸＸＸＸ路XXX号青岛大学附属医院
						</p>
					  </el-form-item>
				  </el-form>
			  </div>
			  <div class="h-formReason">
				 <el-form ::model="formLabelAlign2" :label-position="right" :rules="rules2" ref="formLabelAlign2" :inline="true"  class="demo-ruleForm h-formbLine h-dialogForm">
					 <el-form-item label="过期原因" class="h-elformWrap-1">
						<el-input type="textarea" v-model="formLabelAlign2.explain"></el-input>
					  </el-form-item>
				  </el-form>
			  </div>
		  </div>
		  <div slot="footer" class="dialog-footer">
			  <el-button class="h-btn h-formBtn h-bgwhite" @click="dialogFormVisible = false">取 消</el-button>
			<el-button class="h-btn h-formBtn h-bgblueQ2" @click="dialogFormVisible = false">提交保存</el-button>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data(){
      return{
		  //弹出框
		dialogFormVisible:true,
		formLabelAlign2:{
			formCon1:'',
			formCon2:'',
			formCon3:'',
			formCon4:'',
			formCon5:'',
			formCon6:'',
			formCon7:'',
			formCon8:'',
			formCon9:'',
			formCon10:'',
			formCon11:'',
			explain:''
		},
		rules2: {
		  formCon1: [
			{ required: true, message: '', trigger: 'blur' },
		  ],
		}
      }
    },
}
</script>

<style>
</style>
